// Initialisation de l'objet queryParams pour stocker les paramètres de requête
Shopify.queryParams = {};

/*********************************************************************************************
* Refresh the collection page with the provided filters.
	* 
	* @param {string} url_filters - The URL parameters for the filters.
*/
function refreshCollectionPageWithFilters(url_filters) {
    let currentUrl = '//' + location.host + location.pathname;
    let newPageString = httpGet(`${currentUrl}?${url_filters}&section_id=${returnShopifySectionIdShort()}`);
    
    let newPageEl = document.createElement('DIV');
    newPageEl.innerHTML = newPageString;

    // Sauvegarder l'état des accordéons avant le rafraîchissement
    const activeAccordions = Array.from(document.querySelectorAll('.mm-cf-tag-filter-header.mm-active')).map(header => {
        return header.querySelector('.mm-filter-title-label').textContent.trim();
    });

    var newFilterPanelContent = newPageEl.querySelector('.mm-filter-panel-content');
    if (newFilterPanelContent) {
        document.querySelector('.mm-filter-panel-content').innerHTML = newFilterPanelContent.innerHTML;
    }

    var newSection = newPageEl.querySelector('.mm-grid-card-collection');
    document.querySelector('.mm-grid-card-collection').innerHTML = newSection.innerHTML;

    var activeFilters = newPageEl.querySelectorAll('.active-filters');
    activeFilters.forEach(function (activeFilter) {
        var newActiveFilters = document.querySelectorAll('.active-filters');
        newActiveFilters.forEach(function (newActiveFilter) {
            newActiveFilter.innerHTML = activeFilter.innerHTML;
        });
    });
    
    const newFilterCount = newPageEl.querySelector('.mm-filter-count');
    const newButtonCount = newPageEl.querySelector('.mm-grid-first-container-count-number');
    
    if (newFilterCount) {
        document.querySelector('.mm-filter-count').innerHTML = newFilterCount.innerHTML;
    }
    if (newButtonCount) {
        document.querySelectorAll('.mm-grid-first-container-count-number').forEach(count => {
            count.innerHTML = newButtonCount.innerHTML;
        });
    }

    const newProductCount = newPageEl.querySelector('.mm-grid-first-container-count');
    if (newProductCount) {
        document.querySelector('.mm-grid-first-container-count').innerHTML = newProductCount.innerHTML;
    }
    
    var reloadElems = newPageEl.querySelectorAll('.mm-reload');
    reloadElems.forEach(function (reloadElem, index) {
        var newElems = document.querySelectorAll('.mm-reload');
        newElems[index].innerHTML = reloadElem.innerHTML;
    });

    window.history.replaceState(null, document.title, currentUrl + '?' + url_filters);
    document.querySelector('.mm-grid-card-collection').classList.remove('mm-loading');
    
    // Restaurer l'état des accordéons après le rafraîchissement
    document.querySelectorAll('.mm-cf-tag-filter-header').forEach(header => {
        const title = header.querySelector('.mm-filter-title-label').textContent.trim();
        if (activeAccordions.includes(title)) {
            header.classList.add('mm-active');
            const content = header.nextElementSibling;
            if (content) content.classList.add('mm-active');
        }
    });
    
    checkForChanges();
    mmFiltersAccordeons();
    updateRange();
    adjustSelectWidth();
    updateCheckboxClasses();
    addRangeListeners();
}

/*********************************************************************************************
* Return the Shopify section ID of the collection grid.
	* 
	* @returns {string} - The section ID of the grid.
*/
function returnShopifySectionId() {
    const gridElem = document.querySelector('.mm-grid-collection');
    const gridSection = gridElem.closest('.shopify-section');
    return gridSection.id;
}

/*********************************************************************************************
* Return the Shopify section ID without the 'shopify-section-' prefix.
	* 
	* @returns {string} - The shortened section ID.
*/
function returnShopifySectionIdShort() {
    return returnShopifySectionId().replace('shopify-section-', '');
}

/*********************************************************************************************
* Perform a synchronous GET request.
	* 
	* @param {string} theUrl - The URL to request.
	* @returns {string} - The response text from the request.
*/
function httpGet(theUrl) {
    var xmlHttp = new XMLHttpRequest();
    xmlHttp.open('GET', theUrl, false);  // Synchronous request
    xmlHttp.send(null);
    return xmlHttp.responseText;
}

/*********************************************************************************************
* Check for changes in the filter inputs and submit the form if changes are detected.
	*	
*/
function checkForChanges() {
    var form = document.getElementById('collectionFacetsForm');
    var inputs = form.querySelectorAll('input');

    // Ajouter un listener sur chaque input pour détecter les changements
    inputs.forEach(function (input) {
        input.addEventListener('change', function () {
            // Compter les filtres actifs
            let activeCount = 0;
            const checkboxes = form.querySelectorAll('input[type="checkbox"][name^="filter.v."]:checked');
            const priceInputs = form.querySelectorAll('input[type="number"][name^="filter.v.price"]');
            
            // Compter les cases cochées
            activeCount += checkboxes.length;
            
            // Compter les filtres de prix actifs
            priceInputs.forEach(input => {
                if (input.value !== '') {
                    activeCount++;
                }
            });

            // Soumettre le formulaire
            fakeSubmitForm();

            // Rafraîchir le bouton du filtre spécifique
            refreshSpecificFilterTrigger();
        });
    });
}


/*********************************************************************************************
* Update the sort_by query parameter and reload the page with the new sorting applied.
	* 
	* @param {HTMLSelectElement} select - The select element for sorting.
*/
function mmSortByChanged(select) {
    // Construire la nouvelle URL
    const url = new URL(window.location.href);
    
    if (select.value) {
        url.searchParams.set('sort_by', select.value);
    } else {
        url.searchParams.delete('sort_by');
    }
    
    // Rediriger vers la nouvelle URL
    window.location.href = url.toString();
}

// Ajouter un listener pour le chargement de la page
document.addEventListener('DOMContentLoaded', function() {
    const select = document.getElementById('SortBy');
    if (select) {
        // Vérifier si l'URL contient un paramètre de tri
        const url = new URL(window.location.href);
        if (!url.searchParams.has('sort_by')) {
            // Si pas de tri, sélectionner "Trier par"
            select.value = '';
        }
    }
});

/*********************************************************************************************
* Adds a listener on the change of select for sorting
	* 
*/
const sortByElem = document.querySelector('.sort_by');
if (sortByElem) {
    sortByElem.addEventListener('change', function(e) {
        var value = e.target.value;
        Shopify.queryParams.sort_by = value;
        location.search = new URLSearchParams(Shopify.queryParams).toString();
    });
}

/*********************************************************************************************
* Serialize the form data and refresh the collection page with the filters.
	*
*/
function fakeSubmitForm() {
    let form = document.getElementById("collectionFacetsForm");
    let url_filters = new URLSearchParams(new FormData(form)).toString();
    document.querySelector('.mm-grid-card-collection').classList.add('mm-loading');
    
    // Rafraîchir la collection avec les filtres
    setTimeout(() => {
        refreshCollectionPageWithFilters(url_filters);
    }, "0");
}

/*********************************************************************************************
* Mobile filter drawer functions for screens smaller than 900px.
	*
*/
if (window.innerWidth < 900) {
    
    /*********************************************************************************************
	* Open the mobile filters drawer.
		*
    */
    function mmOpenFiltersMobile() {
        var wrapperMobile = document.querySelector('.mm-grid-second-container-filter');
        wrapperMobile.classList.add('mm-open');
        document.querySelector('html').classList.add('stop-scrolling');  // Empêche le scroll en arrière-plan
    }

    /*********************************************************************************************
	* Close the mobile filters drawer.
		*
	*/
    function mmCloseFiltersMobile() {
        var wrapperMobile = document.querySelector('.mm-grid-second-container-filter');
        wrapperMobile.classList.remove('mm-open');
        document.querySelector('html').classList.remove('stop-scrolling');  // Réactive le scroll
    }

    /*********************************************************************************************
    * Check if the URL contains the 'open_filters' parameter and open the mobile filters drawer if it does.
		* 
    */
    function mmCheckDrawer() {
        var currentUrl = document.location.href.indexOf('?open_filters');
        if (currentUrl !== -1) {
            mmOpenFiltersMobile();
        }
    }
}

/*********************************************************************************************
* Toggle the accordion state for filters. 
	* Automatically opens all by default.
*/
function mmFiltersAccordeons() {
    const filtersHeaders = document.querySelectorAll('.mm-cf-tag-filter-header');

    filtersHeaders.forEach(function(filtersHeader) {
        // En mobile (< 900px), tous les filtres sont fermés par défaut
        // En desktop (>= 900px), tous les filtres sont ouverts par défaut
        if (window.innerWidth >= 900) {
            filtersHeader.classList.add('mm-active');
            const content = filtersHeader.nextElementSibling;
            if (content) content.classList.add('mm-active');
        }

        // Supprimer les anciens écouteurs d'événements
        const newHeader = filtersHeader.cloneNode(true);
        filtersHeader.parentNode.replaceChild(newHeader, filtersHeader);

        // Ajouter le nouvel écouteur d'événements
        newHeader.addEventListener('click', function() {
            newHeader.classList.toggle('mm-active');
            const content = newHeader.nextElementSibling;
            if (content) content.classList.toggle('mm-active');
        });
    });
}

/*********************************************************************************************
* Functions for handling price range sliders.
	*
*/
function updateRange() {
    const minRange = document.getElementById('min-range');
    const maxRange = document.getElementById('max-range');
    const sliderTrack = document.querySelector('.slider-track');
    const minRangeValue = document.getElementById('min-range-value');
    const maxRangeValue = document.getElementById('max-range-value');

    if (!minRange || !maxRange || !sliderTrack || !minRangeValue || !maxRangeValue) return;

    const minValue = parseInt(minRange.value, 10); 
    const maxValue = parseInt(maxRange.value, 10);

    minRangeValue.querySelector('.price-min-value').innerHTML = minValue;
    maxRangeValue.querySelector('.price-max-value').innerHTML = maxValue;

    const minPercent = (minValue / minRange.max) * 100;
    const maxPercent = (maxValue / maxRange.max) * 100;

    sliderTrack.style.background = `linear-gradient(to right, #ddd ${minPercent}%, var(--black-900) ${minPercent}%, var(--black-900) ${maxPercent}%, #ddd ${maxPercent}%)`;

    minRangeValue.style.width = `calc(${minPercent}%)`;
    maxRangeValue.style.width = `calc(${maxPercent}%)`;
}

/*********************************************************************************************
* Event listeners for price sliders
	*
*/
function addRangeListeners() {
    const minRange = document.getElementById('min-range');
    const maxRange = document.getElementById('max-range');
    if (!minRange || !maxRange) return;

    minRange.addEventListener('input', function() {
        if (parseInt(minRange.value) > parseInt(maxRange.value) - 10) {
            minRange.value = maxRange.value - 10;
        }
        updateRange();
    });

    maxRange.addEventListener('input', function() {
        if (parseInt(maxRange.value) < parseInt(minRange.value) + 10) {
            maxRange.value = parseInt(minRange.value) + 10;
        }
        updateRange();
    });
}

/*********************************************************************************************
* Ajuste la largeur du select en fonction de son contenu
*/
function adjustSelectWidth() {
    const select = document.querySelector('.facet-filters__sort');
    if (!select) return;

    // Créer un élément temporaire pour mesurer le texte
    const temp = document.createElement('div');
    temp.style.visibility = 'hidden';
    temp.style.position = 'absolute';
    temp.style.whiteSpace = 'nowrap';
    temp.style.font = window.getComputedStyle(select).font;
    document.body.appendChild(temp);

    // Mesurer la largeur du texte sélectionné
    const selectedOption = select.options[select.selectedIndex];
    temp.textContent = selectedOption.text;
    const width = temp.offsetWidth;

    // Ajuster la largeur du select
    select.style.width = `${width + 40}px`; // 40px pour le padding et le chevron

    // Nettoyer
    document.body.removeChild(temp);
}

/*********************************************************************************************
* Loaded Listenner
	*
*/
window.addEventListener('DOMContentLoaded', (event) => {
    checkForChanges();
	mmFiltersAccordeons();
	updateRange();
    adjustSelectWidth();
    addRangeListeners();
});

/*********************************************************************************************
* Toggle the filter panel visibility
*/
function mmToggleFilterPanel() {
    const filterPanel = document.querySelector('.mm-filter-panel');
    const filterOverlay = document.querySelector('.mm-filter-overlay');
    
    if (!filterPanel || !filterOverlay) return;
    
    filterPanel.classList.toggle('mm-is-open');
    filterOverlay.classList.toggle('mm-is-open');
    document.querySelector('html').classList.toggle('stop-scrolling');
}

/*********************************************************************************************
* Apply filters and close the filter panel
*/
function mmApplyFilters() {
    const filterForm = document.getElementById('collectionFacetsForm');
    if (filterForm) {
        let url_filters = new URLSearchParams(new FormData(filterForm)).toString();
        document.querySelector('.mm-grid-card-collection').classList.add('mm-loading');
        
        // Rafraîchir la collection avec les filtres
        setTimeout(() => {
            refreshCollectionPageWithFilters(url_filters);
            mmToggleFilterPanel(); // Fermer le panneau après l'application des filtres
        }, "0");
    }
}

/*********************************************************************************************
* Clear all filters
*/
function mmClearAllFilters() {
    const filterForm = document.getElementById('collectionFacetsForm');
    if (!filterForm) return;

    const filterCheckboxes = document.querySelectorAll('.mm-cf-tag-filter-list input[type="checkbox"]');
    filterCheckboxes.forEach(checkbox => {
        checkbox.checked = false;
        const parentLabel = checkbox.closest('label');
        if (parentLabel) {
            parentLabel.classList.remove('active');
        }
    });

    const specificFilterCheckboxes = document.querySelectorAll('.mm-specific-filter-dropdown input[type="checkbox"]');
    specificFilterCheckboxes.forEach(checkbox => {
        checkbox.checked = false;
    });

    const priceInputs = document.querySelectorAll('input[type="number"][name^="filter.v.price"]');
    priceInputs.forEach(input => {
        input.value = '';
    });

    const activeFilterElements = document.querySelectorAll('.active-filters');
    activeFilterElements.forEach(element => {
        element.innerHTML = '';
    });

    document.querySelector('.mm-filter-count').innerHTML = '(0)';
    document.querySelector('.mm-grid-first-container-count-number').innerHTML = ' (0)';

    let currentUrl = '//' + location.host + location.pathname;
    let url_filters = '';
    
    const sortBy = document.querySelector('.facet-filters__sort').value;
    if (sortBy) {
        url_filters = `sort_by=${sortBy}`;
    }

    document.querySelector('.mm-grid-card-collection').classList.add('mm-loading');
    
    setTimeout(() => {
        refreshCollectionPageWithFilters(url_filters);
        mmToggleFilterPanel();
    }, "0");
}

/*********************************************************************************************
* Handle specific filter changes
*/
function mmSpecificFilterChanged(checkbox) {
    const form = document.getElementById('collectionFacetsForm');
    if (!form) return;

    const mainCheckbox = form.querySelector(`input[name="${checkbox.name}"][value="${checkbox.value}"]`);
    if (mainCheckbox) {
        mainCheckbox.checked = checkbox.checked;
    }

    var svgSpan = checkbox.parentElement.querySelector('.mm-checkbox-svg');
    if (svgSpan) {
        if (checkbox.checked) {
            svgSpan.classList.add('is-checked');
        } else {
            svgSpan.classList.remove('is-checked');
        }
    }

    var label = checkbox.parentElement;
    if (label && label.tagName.toLowerCase() === 'label') {
        if (checkbox.checked) {
            label.classList.add('active');
        } else {
            label.classList.remove('active');
        }
    }

    var trigger = checkbox.closest('.mm-specific-filter-dropdown').closest('.mm-specific-filter-trigger');
    if (trigger) {
        var checkedCount = trigger.querySelectorAll('.mm-specific-filter-dropdown input[type="checkbox"]:checked').length;
        var countSpan = trigger.querySelector('.mm-grid-first-container-count-number');
        if (countSpan) {
            if (checkedCount > 0) {
                countSpan.textContent = ` (${checkedCount})`;
            } else {
                countSpan.textContent = '';
            }
        }
    }

    fakeSubmitForm();

    refreshSpecificFilterTrigger();
}

/*********************************************************************************************
* Update the checkbox classes
*/
function updateCheckboxClasses() {
    document.querySelectorAll('.mm-cf-tag-filter-list input[type="checkbox"], .mm-specific-filter-dropdown input[type="checkbox"]').forEach(function(checkbox) {
        checkbox.addEventListener('change', function() {
            var svgSpan = checkbox.parentElement.querySelector('.mm-checkbox-svg');
            if (!svgSpan) return;
            if (checkbox.checked) {
                svgSpan.classList.add('is-checked');
            } else {
                svgSpan.classList.remove('is-checked');
            }
        });
    });
}


/*********************************************************************************************
* Refresh the specific filter trigger
*/
function refreshSpecificFilterTrigger() {
    let form = document.getElementById("collectionFacetsForm");
    let url_filters = new URLSearchParams(new FormData(form)).toString();
    let currentUrl = '//' + location.host + location.pathname;
    let sectionId = returnShopifySectionIdShort();
    let url = `${currentUrl}?${url_filters}&section_id=${sectionId}`;

    var xmlHttp = new XMLHttpRequest();
    xmlHttp.open('GET', url, true);
    xmlHttp.onreadystatechange = function() {
        if (xmlHttp.readyState == 4 && xmlHttp.status == 200) {
            let newPageEl = document.createElement('DIV');
            newPageEl.innerHTML = xmlHttp.responseText;

            var newTrigger = newPageEl.querySelector('.mm-specific-filter-trigger');
            var currentTrigger = document.querySelector('.mm-specific-filter-trigger');
            if (newTrigger && currentTrigger) {
                currentTrigger.innerHTML = newTrigger.innerHTML;
            }
        }
    };
    xmlHttp.send(null);
}

/*********************************************************************************************
* Gère la hauteur et la position du panneau de filtres en fonction du scroll
*/
if (window.innerWidth < 768) {
    function updateFilterPanelPosition() {
        const filterPanel = document.querySelector('.mm-filter-panel-content');
        const header = document.querySelector('.mm-section-header');
        const announcementBar = document.querySelector('.mm-section-announcement-bar');
        
        if (!filterPanel || !header) return;
        
        const headerHeight = header.offsetHeight;
        const announcementBarHeight = announcementBar ? announcementBar.offsetHeight : 0;
        const totalHeaderHeight = headerHeight + announcementBarHeight;
        
        const isAnnouncementBarVisible = announcementBar ? 
            announcementBar.getBoundingClientRect().top >= 0 : true;
        
        if (isAnnouncementBarVisible) {
            filterPanel.style.top = `${totalHeaderHeight}px`;
            filterPanel.style.height = `calc(100dvh - ${totalHeaderHeight}px)`;
        } else {
            filterPanel.style.top = `${headerHeight}px`;
            filterPanel.style.height = `calc(100dvh - ${headerHeight}px)`;
        }
    }
    
    window.addEventListener('scroll', updateFilterPanelPosition);
    window.addEventListener('resize', updateFilterPanelPosition);
    
    document.addEventListener('DOMContentLoaded', () => {
        updateFilterPanelPosition();
        checkForChanges();
        mmFiltersAccordeons();
        updateRange();
        adjustSelectWidth();
        addRangeListeners();
    });
}
